// extracted by mini-css-extract-plugin
export default {"product_thumbnail":"product_thumbnail__d445f515","image":"image__d445f515"};